export default __webpack_public_path__ + "static/media/1.996389f9.jpg";